import { configString } from 'config/appConfigUtils';

export function algoliaApiGetSearchIndex(sort?: string | null | undefined) {
  if (sort === 'relevance') {
    return configString('algolia', 'siteIndexName');
  }

  return configString('algolia', 'sitePublishedDescIndexName');
}
